import { Component, OnInit } from '@angular/core';
import { Footer, FooterLink, LegalSystemPage } from '../../shared/legal-system.model';

import { LegalSystemsService } from '../../services/legal-systems.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit {

  links: FooterLink[] = [];
  columns: FooterLink[][] = [[], [], [], []];

  owner = 'Curious Resource';          // 👈 put owner name here
  siteName = 'מערכת עולמית במתח. משאבים כגורם לעימותים'; // 👈 optional
  currentYear = new Date().getFullYear();

  constructor(private readonly legal: LegalSystemsService){}

  ngOnInit(): void {
    this.legal.getSharedFooter('footer').subscribe((listLinks: Footer)=>{
       this.links = listLinks.links  ?? [];
       this.columns = [[], [], [], []];
       this.links.forEach((link, i) => this.columns[i % 4].push(link));
    });
  }

}
